// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disabled-block .page-subtitle[data-v-5bdf28fe]{color:#c4c4c4}.disabled-block[data-v-5bdf28fe] label{color:#c4c4c4!important}", ""]);
// Exports
module.exports = exports;
